"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var Component = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Component, _PureComponent);

  var _super = (0, _createSuper2["default"])(Component);

  function Component() {
    (0, _classCallCheck2["default"])(this, Component);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Component, [{
    key: "_renderItem",
    value: function _renderItem() {
      var _this$props = this.props,
          _data = _this$props._data,
          children = _this$props.children;
      return _react["default"].Children.map(children, function (Item, index) {
        var _cn;

        if (!Item) {
          return null;
        }

        var params = Item['props'];
        var title = params.title,
            width = params.width,
            align = params.align;
        var columnProps = {};

        if (width) {
          columnProps['width'] = width;
        }

        var titleClassName = (0, _classnames["default"])(_defaultModule["default"]['title'], (_cn = {}, (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['title--left'], align === 'left'), (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['title--right'], align === 'right'), _cn));
        return /*#__PURE__*/_react["default"].createElement("td", Object.assign({
          className: _defaultModule["default"]['col']
        }, columnProps), /*#__PURE__*/_react["default"].createElement("span", {
          className: titleClassName,
          "data-location": _data ? "".concat(_data, ".header.col[").concat(index, "]") : "header.col[".concat(index, "]")
        }, title));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _data = this.props._data;
      return /*#__PURE__*/_react["default"].createElement("thead", {
        className: _defaultModule["default"]['header'],
        "data-location": _data ? "".concat(_data, ".header") : 'header'
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        className: _defaultModule["default"]['row']
      }, this._renderItem()));
    }
  }]);
  return Component;
}(_react.PureComponent);

var _default = Component;
exports["default"] = _default;